export default "__VITE_ASSET__DFEnKZU8__"